// [AB#1834] DIDOMI_API_CONFIG supprimée : constante morte — le ConsentManager ne fait plus
// aucun appel réseau (check local du profil Didomi fourni par le front via le Web SDK Didomi),
// et l'Azure Function Core api/didomi est décommissionnée (aucun appelant).

export enum ConsentIds {
    CGU = "condition-6PZg7BEx",
    PRIVATE_POLICY = "privatepo-QQJG7tR3",
    ACCESS_MAIL_SERVICE = "mailservi-yGLJ6Cjy",
    ACCESS_VOICE = "voicefeat-XXnGwWEb",
    ACCESS_LOCAL_DATA = "accessloc-6FQm289W",
}
